import { createApi } from '@reduxjs/toolkit/query/react';
import { createAccountGSTDetails, createAccountMaster, createAccountMasterCustom, createBankDetails, deleteAccountMaster, getAccountGSTDetails, listAccountMasterv2Custom, listaccountopeningbalancev2, updateAccountMaster } from '../../graphql';
import { baseQuery } from '../baseQuery';
import { dashboardApi } from './dashboardApi';

const invalidateDashboardCache = async (_arg, { dispatch, queryFulfilled }) => {
  try {
    await queryFulfilled;
    dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock']));
  } catch {
    // no-op
  }
};

export const listAccountMasterv2Api = createApi({
    reducerPath: 'listAccountMasterv2',
    baseQuery: baseQuery,
    tagTypes: ['listAccountMaster', 'allaccounts'],
    endpoints: (builder) => ({
        listAccountMasterv2: builder.query({
            query: () => ({ body: listAccountMasterv2Custom }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['listAccountMaster', 'allaccounts'],
        }),

        getAccountGSTDetailsData: builder.query({
            query: (variables) => ({ body: getAccountGSTDetails, variables }),
            keepUnusedDataFor: 300,
            refetchOnMountOrArgChange: true,
            providesTags: ['accountGSTDetails'],
        }),

        createAccountMaster: builder.mutation({
            query: (variables) => ({ body: createAccountMasterCustom, variables }),
            invalidatesTags: ['listAccountMaster', 'allaccounts'],
            onQueryStarted: invalidateDashboardCache,
        }),
        createAccountGSTDetails: builder.mutation({
            query: (variables) => ({ body: createAccountGSTDetails, variables }),
        }),
        createBankDetails: builder.mutation({
            query: (variables) => ({ body: createBankDetails, variables }),
            invalidatesTags: ['listAccountMaster'],
        }),
        updateAccountMaster: builder.mutation({
            query: (variables) => ({ body: updateAccountMaster, variables }),
            invalidatesTags: ['listAccountMaster', 'allaccounts'],
            onQueryStarted: invalidateDashboardCache,
        }),
        deleteAccountMaster: builder.mutation({
            query: (variables) => ({ body: deleteAccountMaster, variables }),
            invalidatesTags: ['listAccountMaster', 'allaccounts'],
            onQueryStarted: invalidateDashboardCache,
        }),
    }),
});

export const { useListAccountMasterv2Query, useLazyListAccountMasterv2Query, useCreateAccountMasterMutation, useCreateAccountGSTDetailsMutation, useCreateBankDetailsMutation, useUpdateAccountMasterMutation, useGetAccountGSTDetailsDataQuery, useDeleteAccountMasterMutation } = listAccountMasterv2Api;
